// Detect when the hero has scorlled out of the viewport so we can update the header syles
const headerEl = document.querySelector('.Header');
const heroEl = document.querySelector('.Hero-content');

if (headerEl && heroEl) {
  const observer = new IntersectionObserver((entries) => {
    let entry = entries[0];
    headerEl.classList.toggle('is-below-hero', !entry.isIntersecting);
  },
  {
    rootMargin: '-71px 0px 0px 0px',// add top offset to switch colors sooner
    threshold: [0]
  });

  observer.observe(heroEl);
}
